import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=1eb0efbf&scoped=true"
import script from "./Workers.vue?vue&type=script&lang=ts"
export * from "./Workers.vue?vue&type=script&lang=ts"
import style0 from "./Workers.vue?vue&type=style&index=0&id=1eb0efbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb0efbf",
  null
  
)

export default component.exports